module.exports = __webpack_public_path__ + "img/electric_use_selected.15f502d7.svg";